<template>
  <SogPage
    id="page"
    :title="_title"
  >
    <SogCard>
      <SogCardContent>
        <GdvAccessFormComponent
          ref="_form"
          :data="_gdvAccess"
          :is-create="_isCreate"
        />
      </SogCardContent>
      <SogCardActions>
        <SogCardActionButton
          :kind="SogButtonKind.Save"
          @click="onSave()"
        >
          Speichern
        </SogCardActionButton>
        <SogCardActionButton
          :kind="SogButtonKind.Cancel"
          @click="onCancel"
        >
          Abbrechen
        </SogCardActionButton>
      </SogCardActions>
    </SogCard>
  </SogPage>
</template>

<script setup lang="ts">

import GdvAccessFormComponent from "@/modules/Gdv/components/GdvAccessFormComponent.vue";
import SogPage from "@/shared/ui/SogPage.vue";
import GdvAccess from "@/shared/model/GdvAccess";
import apiGdv from "@/modules/Gdv/api";
import {onMounted, reactive, ref} from "vue";
import {useSpinner} from "@/shared/composables/SogSpinner";
import {useNavigationStore} from "@/modules/Navigation/store";
import {RouteLocationNormalizedLoaded, useRoute, useRouter} from "vue-router";
import copyTo from "@/shared/utils/CopyTo";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import {useGdvStore} from "@/modules/Gdv/store";
import notificationService from "@/shared/services/NotificationService";
import {computed} from "vue";

const _gdvStore = useGdvStore();
const _gdvAccess = reactive<GdvAccess>(new GdvAccess())
const _spinner = useSpinner();
const _navigationStore = useNavigationStore();
const _router = useRouter();
const _form = ref<InstanceType<typeof GdvAccessFormComponent> | null>()
const _action = ref("");
const _title = ref("");
const _isCreate = computed(() => _action.value === "create");

function p_setTitle() {
  _title.value = "";
  if (_action.value === "edit") {
    _title.value = "Gdv-Zugang bearbeiten"
  }
  if (_action.value === "create") {
    _title.value = "Gdv-Zugang anlegen"
  }

}

async function p_init(route: RouteLocationNormalizedLoaded) {
  _action.value = route.params.action as string ?? "";
  if (_action.value === 'edit' && (!_navigationStore.currentGdvAccessId || !_gdvStore.gdvAccess || _navigationStore.currentGdvAccessId !== _gdvStore.gdvAccess.id)) {
    _router.back()
    return;
  }
  try {
    _spinner.show()
    {
//      copyTo(_clipboardStore.gdvaccess, _gdvAccess.value)
      copyTo(_gdvStore.gdvAccess, _gdvAccess)
    }
  } finally {
    _spinner.hide()
  }
  p_setTitle()
}


//_gdvAccess.value  _clipboardStore.gdvaccess;
onMounted(async () => {
  const route = useRoute();
  await p_init(route)
  //console.log(_gdvAccess)

})

function onCancel() {
  _router.back()
}

async function onSave() {
  if (_action.value === "create" && !_form.value.getResults().id) {
    notificationService.error("Bitte eine ID eingeben");
    return
  }
  if (_form.value && _form.value.validate()) {
    const result = _form.value.getResults();
    const res = await apiGdv.update(result);
    if (res) {
      notificationService.success("Änderung wurde erfolgreich gespeichert")
      _router.back()
    }
    return
  }

}

</script>

<style scoped>

</style>
